<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-title>
            <v-btn icon @click="$emit('fechar')">
                <v-icon>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <h1>CONTRATO PADRÃO</h1>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text v-if="!loading">
            <v-layout row wrap justify-space-around fill-height>
                <v-flex xs12>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <h2
                                v-on="on"
                                class="text-center"
                                style="text-align: center;"
                            >
                                Geral
                            </h2>
                        </template>
                        <span>Pode ser usado em todos os tipos de empresa</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                    v-model="tem_assinatura"
                    label="Tem assinatura"
                    color="primary"
                    ></v-switch>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs12>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <h2
                                v-on="on"
                                class="text-center"
                                style="text-align: center;"
                            >
                                Frota de veículos
                            </h2>
                        </template>
                        <span>Restrito para Empresas do tipo Frota de veículos</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs12 v-if="tem_assinatura">
                    <v-text-field
                    v-model.lazy="contrato.valor_assinatura"
                    v-money="money"
                    v-if="rendering"
                    prefix="R$"
                    outline
                    label="Valor da assinatura"
                    hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                    v-model="tem_taxa_por_veiculo"
                    label="Tem taxa por veículo"
                    color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_veiculo">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_veiculo"
                        v-money="money"
                        v-if="rendering"
                        prefix="R$"
                        outline
                        label="Taxa por veículo"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                    v-model="tem_taxa_por_abastecimento"
                    label="Tem percentual em cima do abastecimento"
                    color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_abastecimento">
                    <v-text-field
                        v-model="contrato.taxa_por_abastecimento"
                        v-if="rendering"
                        suffix="%"
                        outline
                        label="Taxa por abastecimetno"
                        hide-details
                        type="number"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_abastecimento_carteira"
                        label="Tem percentual em cima do abastecimento com a carteira"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_abastecimento_carteira">
                    <v-text-field
                        v-model="contrato.taxa_por_abastecimento_carteira"
                        v-if="rendering"
                        suffix="%"
                        outline
                        label="Taxa por abastecimetno da carteira"
                        hide-details
                        type="number"
                    ></v-text-field>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs12>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <h2
                                v-on="on"
                                class="text-center"
                                style="text-align: center;"
                            >
                                Revendedora de veículos
                            </h2>
                        </template>
                        <span>Restrito para Empresas do tipo Revendedora de veículos</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs12 class="mt-4">
                    <h4># Taxas de compra e venda (Padrão)</h4>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_finalizacao_empresa"
                        label="Tem taxa de finalização da negociação para empresa (Compradora) ao negociar com cliente"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_finalizacao_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_finalizacao_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para empresa (Compradora) ao negociar com cliente"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_finalizacao_empresa_para_empresa"
                        label="Tem taxa de finalização da negociação para empresa (Compradora) ao negociar com empresa"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_finalizacao_empresa_para_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_finalizacao_empresa_para_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para empresa (Compradora) ao negociar com empresa"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_finalizacao_cliente"
                        label="Tem taxa de finalização da negociação para cliente (Comprador)"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_finalizacao_cliente">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_finalizacao_cliente"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para cliente (Comprador)"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_negociacao_empresa"
                        label="Tem taxa de finalização da negociação para empresa (Vendedora) ao negociar com cliente"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_negociacao_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_negociacao_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para empresa (Vendedora) ao negociar com cliente"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_negociacao_empresa_para_empresa"
                        label="Tem taxa de finalização da negociação para empresa (Vendedora) ao negociar com empresa"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_negociacao_empresa_para_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_negociacao_empresa_para_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para empresa (Vendedora) ao negociar com empresa"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_negociacao_cliente"
                        label="Tem taxa de finalização da negociação para cliente (Vendedor)"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_negociacao_cliente">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_negociacao_cliente"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de finalização da negociação para cliente"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <h4># Taxas de fila</h4>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_fila_empresa_para_cliente"
                        label="Tem taxa para visualizar fila toda (empresa para cliente)"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_fila_empresa_para_cliente">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_fila_empresa_para_cliente"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de visualização da fila (empresa para cliente)"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_fila_empresa_para_empresa"
                        label="Tem taxa para visualizar fila toda (empresa para empresa)"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_fila_empresa_para_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_fila_empresa_para_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de visualização da fila (empresa para empresa)"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_por_fila_cliente_para_empresa"
                        label="Tem taxa para visualizar fila toda (cliente para empresa)"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_fila_cliente_para_empresa">
                    <v-text-field
                        v-model.lazy="contrato.taxa_por_fila_cliente_para_empresa"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa de visualização da fila (cliente para empresa)"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <h4># Taxas de leilão</h4>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_leilao_empresa_compradora"
                        label="Tem taxa para empresa que está comprando"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_leilao_empresa_compradora">
                    <v-text-field
                        v-model.lazy="contrato.taxa_leilao_empresa_compradora"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa cobrada de empresa que está comprando"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_leilao_empresa_vendedora"
                        label="Tem taxa para empresa que está vendendo"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_leilao_empresa_vendedora">
                    <v-text-field
                        v-model.lazy="contrato.taxa_leilao_empresa_vendedora"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa cobrada de empresa que está vendendo"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-switch
                        v-model="tem_taxa_leilao_cliente_vendedor"
                        label="Tem taxa para cliente que está vendendo"
                        color="primary"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_leilao_cliente_vendedor">
                    <v-text-field
                        v-model.lazy="contrato.taxa_leilao_cliente_vendedor"
                        v-if="rendering"
                        outline
                        v-money="money"
                        prefix="R$"
                        label="taxa cobrada de cliente que está vendendo"
                        hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text v-else>
            <v-layout justify-center>
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn color="success" class="mb-2" block round @click="alterarContratoPadrao">
                <v-icon class="mr-1">save</v-icon>
                salvar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    data: () => ({
        rendering: true,
        tem_assinatura: false,
        tem_taxa_por_veiculo: false,
        tem_taxa_por_abastecimento: false,
        tem_taxa_por_abastecimento_carteira: false,
        tem_taxa_por_negociacao_cliente: false,
        tem_taxa_por_negociacao_empresa: false,
        tem_taxa_por_negociacao_empresa_para_empresa: false,
        tem_taxa_por_finalizacao_cliente: false,
        tem_taxa_por_finalizacao_empresa: false,
        tem_taxa_por_finalizacao_empresa_para_empresa: false,
        tem_taxa_por_fila_empresa_para_cliente: false,
        tem_taxa_por_fila_empresa_para_empresa: false,
        tem_taxa_por_fila_cliente_para_empresa: false,
        tem_taxa_leilao_empresa_compradora: false,
        tem_taxa_leilao_empresa_vendedora: false,
        tem_taxa_leilao_cliente_vendedor: false,
        contrato: {
            taxa_por_abastecimento: undefined,
            taxa_por_abastecimento_carteira: undefined,
            taxa_por_veiculo: undefined,
            valor_assinatura: undefined,
            taxa_por_negociacao_cliente: undefined,
            taxa_por_negociacao_empresa: undefined,
            taxa_por_negociacao_empresa_para_empresa: undefined,
            taxa_por_finalizacao_cliente: undefined,
            taxa_por_finalizacao_empresa: undefined,
            taxa_por_finalizacao_empresa_para_empresa: undefined,
            taxa_por_fila_empresa_para_cliente: undefined,
            taxa_por_fila_empresa_para_empresa: undefined,
            taxa_por_fila_cliente_para_empresa: undefined,
            taxa_leilao_empresa_compradora: undefined,
            taxa_leilao_empresa_vendedora: undefined,
            taxa_leilao_cliente_vendedor: undefined
        },
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            precision: 2,
            masked: false
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        tem_taxa_por_abastecimento (val) {
            if (!val) {
                this.contrato.taxa_por_abastecimento = undefined
            }
        },
        tem_taxa_por_abastecimento_carteira (val) {
            if (!val) {
                this.contrato.taxa_por_abastecimento_carteira = undefined
            }
        },
        tem_taxa_por_veiculo (val) {
            if (!val) {
                this.contrato.taxa_por_veiculo = undefined
            }
        },
        tem_assinatura (val) {
            if (!val) {
                this.contrato.valor_assinatura = undefined
            }
        },
        tem_taxa_por_finalizacao_cliente (val) {
            if (!val) {
                this.contrato.taxa_por_finalizacao_cliente = undefined
            }
        },
        tem_taxa_por_finalizacao_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_finalizacao_empresa = undefined
            }
        },
        tem_taxa_por_finalizacao_empresa_para_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_finalizacao_empresa_para_empresa = undefined
            }
        },
        tem_taxa_por_negociacao_cliente (val) {
            if (!val) {
                this.contrato.taxa_por_negociacao_cliente = undefined
            }
        },
        tem_taxa_por_negociacao_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_negociacao_empresa = undefined
            }
        },
        tem_taxa_por_negociacao_empresa_para_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_negociacao_empresa_para_empresa = undefined
            }
        },
        tem_taxa_por_fila_empresa_para_cliente (val) {
            if (!val) {
                this.contrato.taxa_por_fila_empresa_para_cliente = undefined
            }
        },
        tem_taxa_por_fila_empresa_para_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_fila_empresa_para_empresa = undefined
            }
        },
        tem_taxa_por_fila_cliente_para_empresa (val) {
            if (!val) {
                this.contrato.taxa_por_fila_cliente_para_empresa = undefined
            }
        },
        tem_taxa_leilao_empresa_compradora (val) {
            if (!val) {
                this.contrato.taxa_leilao_empresa_compradora = undefined
            }
        },
        tem_taxa_leilao_empresa_vendedora (val) {
            if (!val) {
                this.contrato.taxa_leilao_empresa_vendedora = undefined
            }
        },
        tem_taxa_leilao_cliente_vendedor (val) {
            if (!val) {
                this.contrato.taxa_leilao_cliente_vendedor = undefined
            }
        }
    },
    beforeMount () {
        this.pegarContrato()
    },
    methods: {
        pegarContrato () {
            this.$store.dispatch('contratoEmpresa', { method: 'GET' }).then(contrato => {
                this.contrato.taxa_por_abastecimento = contrato.taxa_por_abastecimento ? contrato.taxa_por_abastecimento : undefined
                this.contrato.taxa_por_abastecimento_carteira = contrato.taxa_por_abastecimento_carteira ? contrato.taxa_por_abastecimento_carteira : undefined
                this.contrato.taxa_por_veiculo = contrato.taxa_por_veiculo ? contrato.taxa_por_veiculo : undefined
                this.contrato.valor_assinatura = contrato.valor_assinatura ? contrato.valor_assinatura : undefined
                this.contrato.taxa_por_finalizacao_empresa = contrato.taxa_por_finalizacao_empresa ? contrato.taxa_por_finalizacao_empresa : undefined
                this.contrato.taxa_por_finalizacao_empresa_para_empresa = contrato.taxa_por_finalizacao_empresa_para_empresa ? contrato.taxa_por_finalizacao_empresa_para_empresa : undefined
                this.contrato.taxa_por_finalizacao_cliente = contrato.taxa_por_finalizacao_cliente ? contrato.taxa_por_finalizacao_cliente : undefined
                this.contrato.taxa_por_negociacao_empresa = contrato.taxa_por_negociacao_empresa ? contrato.taxa_por_negociacao_empresa : undefined
                this.contrato.taxa_por_negociacao_empresa_para_empresa = contrato.taxa_por_negociacao_empresa_para_empresa ? contrato.taxa_por_negociacao_empresa_para_empresa : undefined
                this.contrato.taxa_por_negociacao_cliente = contrato.taxa_por_negociacao_cliente ? contrato.taxa_por_negociacao_cliente : undefined
                this.contrato.taxa_por_fila_empresa_para_cliente = contrato.taxa_por_fila_empresa_para_cliente ? contrato.taxa_por_fila_empresa_para_cliente : undefined
                this.contrato.taxa_por_fila_empresa_para_empresa = contrato.taxa_por_fila_empresa_para_empresa ? contrato.taxa_por_fila_empresa_para_empresa : undefined
                this.contrato.taxa_por_fila_cliente_para_empresa = contrato.taxa_por_fila_cliente_para_empresa ? contrato.taxa_por_fila_cliente_para_empresa : undefined
                this.contrato.taxa_leilao_empresa_compradora = contrato.taxa_leilao_empresa_compradora ? contrato.taxa_leilao_empresa_compradora : undefined
                this.contrato.taxa_leilao_empresa_vendedora = contrato.taxa_leilao_empresa_vendedora ? contrato.taxa_leilao_empresa_vendedora : undefined
                this.contrato.taxa_leilao_cliente_vendedor = contrato.taxa_leilao_cliente_vendedor ? contrato.taxa_leilao_cliente_vendedor : undefined

                this.tem_taxa_por_abastecimento = !!this.contrato.taxa_por_abastecimento
                this.tem_taxa_por_abastecimento_carteira = !!this.contrato.taxa_por_abastecimento_carteira
                this.tem_taxa_por_veiculo = !!this.contrato.taxa_por_veiculo
                this.tem_assinatura = !!this.contrato.valor_assinatura
                this.tem_taxa_por_finalizacao_empresa = !!this.contrato.taxa_por_finalizacao_empresa
                this.tem_taxa_por_finalizacao_empresa_para_empresa = !!this.contrato.taxa_por_finalizacao_empresa_para_empresa
                this.tem_taxa_por_finalizacao_cliente = !!this.contrato.taxa_por_finalizacao_cliente
                this.tem_taxa_por_negociacao_empresa = !!this.contrato.taxa_por_negociacao_empresa
                this.tem_taxa_por_negociacao_empresa_para_empresa = !!this.contrato.taxa_por_negociacao_empresa_para_empresa
                this.tem_taxa_por_negociacao_cliente = !!this.contrato.taxa_por_negociacao_cliente
                this.tem_taxa_por_fila_empresa_para_cliente = !!this.contrato.taxa_por_fila_empresa_para_cliente
                this.tem_taxa_por_fila_empresa_para_empresa = !!this.contrato.taxa_por_fila_empresa_para_empresa
                this.tem_taxa_por_fila_cliente_para_empresa = !!this.contrato.taxa_por_fila_cliente_para_empresa

                this.tem_taxa_leilao_empresa_compradora = !!this.contrato.taxa_leilao_empresa_compradora
                this.tem_taxa_leilao_empresa_vendedora = !!this.contrato.taxa_leilao_empresa_vendedora
                this.tem_taxa_leilao_cliente_vendedor = !!this.contrato.taxa_leilao_cliente_vendedor
            })
        },
        alterarContratoPadrao () {
            this.$store.dispatch('contratoEmpresa', {
                method: 'POST',
                taxa_por_abastecimento: this.tem_taxa_por_abastecimento ? this.contrato.taxa_por_abastecimento : null,
                taxa_por_abastecimento_carteira: this.tem_taxa_por_abastecimento_carteira ? this.contrato.taxa_por_abastecimento_carteira : null,
                taxa_por_veiculo: this.tem_taxa_por_veiculo ? this.contrato.taxa_por_veiculo.replaceAll('.', '').replace(',', '.') : null,
                valor_assinatura: this.tem_assinatura ? this.contrato.valor_assinatura.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_finalizacao_cliente: this.tem_taxa_por_finalizacao_cliente ? this.contrato.taxa_por_finalizacao_cliente.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_finalizacao_empresa: this.tem_taxa_por_finalizacao_empresa ? this.contrato.taxa_por_finalizacao_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_finalizacao_empresa_para_empresa: this.tem_taxa_por_finalizacao_empresa_para_empresa ? this.contrato.taxa_por_finalizacao_empresa_para_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_negociacao_cliente: this.tem_taxa_por_negociacao_cliente ? this.contrato.taxa_por_negociacao_cliente.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_negociacao_empresa: this.tem_taxa_por_negociacao_empresa ? this.contrato.taxa_por_negociacao_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_negociacao_empresa_para_empresa: this.tem_taxa_por_negociacao_empresa_para_empresa ? this.contrato.taxa_por_negociacao_empresa_para_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_fila_empresa_para_cliente: this.tem_taxa_por_fila_empresa_para_cliente ? this.contrato.taxa_por_fila_empresa_para_cliente.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_fila_empresa_para_empresa: this.tem_taxa_por_fila_empresa_para_empresa ? this.contrato.taxa_por_fila_empresa_para_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_por_fila_cliente_para_empresa: this.tem_taxa_por_fila_cliente_para_empresa ? this.contrato.taxa_por_fila_cliente_para_empresa.replaceAll('.', '').replace(',', '.') : null,
                taxa_leilao_empresa_compradora: this.tem_taxa_leilao_empresa_compradora ? this.contrato.taxa_leilao_empresa_compradora.replaceAll('.', '').replace(',', '.') : null,
                taxa_leilao_empresa_vendedora: this.tem_taxa_leilao_empresa_vendedora ? this.contrato.taxa_leilao_empresa_vendedora.replaceAll('.', '').replace(',', '.') : null,
                taxa_leilao_cliente_vendedor: this.tem_taxa_leilao_cliente_vendedor ? this.contrato.taxa_leilao_cliente_vendedor.replaceAll('.', '').replace(',', '.') : null
            }).then(() => {
                this.$emit('success', 'Contrato Padrão atualizado com sucesso.')
            })
        }
    }
}
</script>
